<template>
  <div class="new-loading">
    <NewLoadingIcon class="align-middle" />
    <h1 class="new-loading__text whitespace-pre-line text-14">{{ loadingText }}</h1>
    <p
      v-if="loadingSubText"
      class="new-loading_sub-text text-14"
    >
      {{ loadingSubText }}
    </p>
  </div>
</template>

<script>
import NewLoadingIcon from './NewLoadingIcon.vue';

export default {
  components: {
    NewLoadingIcon
  },
  props: {
    loadingText: {
      type: String,
      default: ''
    },
    loadingSubText: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';
.new-loading__text {
  margin-top: px2rem144(20);
  font-weight: 400;
}
.new-loading {
  position: absolute;
  width:  px2rem144(300);
  height:  px2rem144(300);
  transform: translate(-50%);
  top:0;
  left:50%;
  padding-top: px2rem144(200);
  font-size: px2rem144(20);
  color: #4dc3ff;
  line-height: 1.46;
  text-align: center;
}
</style>
